import type { GetStaticProps } from 'next';
import { fetchBlogPosts } from '../utils/api/fetchStrapiData';
import Contact from '../views/contactPage';

export const getStaticProps: GetStaticProps = async () => {
  const data = await fetchBlogPosts();

  return {
    props: { blogPosts: data },
  };
};
export default Contact;
